import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Home from './Home';

/* Signed-in, active users land on their condo dashboard instead of the
   marketing home page — the first condo when they belong to several.
   Rendering is gated on auth resolving so the marketing page never flashes
   on screen before the redirect. */
function Landing() {
  const { user, isAuthenticated, isActive, loading } = useAuth();

  if (loading) return null;

  const condos = user?.condos || [];
  if (isAuthenticated && isActive && condos.length > 0 && condos[0]?.slug) {
    return <Navigate to={`/${condos[0].slug}`} replace />;
  }

  return <Home />;
}

export default Landing;
